__turbopack_context__.v({
  "active": "index-module__6HZ5Gq__active",
  "icon": "index-module__6HZ5Gq__icon",
  "item": "index-module__6HZ5Gq__item",
  "label": "index-module__6HZ5Gq__label",
  "progression": "index-module__6HZ5Gq__progression",
  "progressionIcon": "index-module__6HZ5Gq__progressionIcon",
});
